class RTCDataView {
  private _dataview: DataView
  _position = 0
  constructor(buffer: ArrayBuffer) {
    this._dataview = new DataView(buffer)
  }

  /**
   * buffer length
   * @return {number}
   */
  get length() {
    return this.buffer.byteLength
  }

  get buffer() {
    return this._dataview.buffer
  }

  /**
   * set current read position of data-view
   * @param value
   */
  set position(value) {
    this._position = value
  }

  /**
   * set current read position of data-view
   * @param value
   */
  get position() {
    return this._position
  }

  /**
   * move read position backward
   * @param count
   */
  back(count: number) {
    this.position -= count
  }

  getUint8(offset: number) {
    return this._dataview.getUint8(offset)
  }

  getInt8(offset: number) {
    return this._dataview.getInt8(offset)
  }

  getInt16(offset: number) {
    return this._dataview.getInt16(offset)
  }
  getUint16(offset: number) {
    return this._dataview.getUint16(offset)
  }
  getUint32(offset: number) {
    return this._dataview.getUint32(offset)
  }

  getInt32(offset: number) {
    return this._dataview.getInt32(offset)
  }
  /**
   * move read position forward
   * @param count
   */
  skip(count: number) {
    const loop = Math.floor(count / 4)
    const last = count % 4
    for (let i = 0; i < loop; i++) {
      RTCDataView.readByte(this, 4)
    }
    if (last > 0) {
      RTCDataView.readByte(this, last)
    }
  }

  static readByte(buffer: RTCDataView, size: number, sign?: boolean) {
    let res
    switch (size) {
      case 1:
        if (sign) {
          res = buffer.getInt8(buffer.position)
        } else {
          res = buffer.getUint8(buffer.position)
        }
        break
      case 2:
        if (sign) {
          res = buffer.getInt16(buffer.position)
        } else {
          res = buffer.getUint16(buffer.position)
        }
        break
      case 3:
        if (sign) {
          throw new Error('not supported for readByte 3')
        } else {
          res = buffer.getUint8(buffer.position) << 16
          res |= buffer.getUint8(buffer.position + 1) << 8
          res |= buffer.getUint8(buffer.position + 2)
        }
        break
      case 4:
        if (sign) {
          res = buffer.getInt32(buffer.position)
        } else {
          res = buffer.getUint32(buffer.position)
        }
        break
      case 8:
        if (sign) {
          throw new Error('not supported for readBody 8')
        } else {
          res = buffer.getUint32(buffer.position) << 32
          res |= buffer.getUint32(buffer.position + 4)
        }
        break
      default:
        res = ''
    }
    buffer.position += size
    return res
  }

  /**
   * @return {Number}
   */
  readUint8() {
    return RTCDataView.readByte(this, 1)
  }

  /**
   * @return {Number}
   */
  readUint16() {
    return RTCDataView.readByte(this, 2)
  }

  /**
   * @return {Number}
   */
  readUint24() {
    return RTCDataView.readByte(this, 3)
  }

  /**
   * @return {Number}
   */
  readUint32() {
    return RTCDataView.readByte(this, 4)
  }

  /**
   * @return {Number}
   */
  readUint64() {
    return RTCDataView.readByte(this, 8)
  }

  /**
   * @return {Number}
   */
  readInt8() {
    return RTCDataView.readByte(this, 1, true)
  }

  /**
   * @return {Number}
   */
  readInt16() {
    return RTCDataView.readByte(this, 2, true)
  }

  /**
   * @return {Number}
   */
  readInt32() {
    return RTCDataView.readByte(this, 4, true)
  }

  /**
   * @return {Uint8Array}
   */
  writeUint32(value: number) {
    return new Uint8Array([
      (value >>> 24) & 0xff,
      (value >>> 16) & 0xff,
      (value >>> 8) & 0xff,
      value & 0xff
    ])
  }
}

export default RTCDataView
